module.exports = __webpack_public_path__ + "static/media/point7.03a4e0f9.png";